import { SourceTypeEnum, TagLabel } from "./common";
import { Product, ProductPrice } from "./product";
import { InventoryOrdersItem, PurchaseOrderItem, Supplier, SupplierPrice } from "./purchase";
import { SaleOrder, SaleOrderItemState } from "./sales";
import { User } from "./user";

export enum RequirementConfirmTypeEnum {
  FINANCE = 1, // 财务
  SALE, // 业务
  PROD, // 生产
  MATERIAL_CONTROL, // 物控
  PURCHASE, // 采购
  COMMODITY, // 产品
}

export enum RequirementConfirmValueEnum {
  NOT_PASS,
  PASSED,
  REJECTED,
}

export enum RequirementConfirmShowEnum {
  HIDDEN,
  SHOW,
}

export enum RequirementStatusEnum {
  CLOSE,
  OPEN_PENDING,
  OPEN_DONE,
}

export interface RequirementConfirmAdd {
  value: RequirementConfirmValueEnum;
  desc: string;
}

export interface RequirementConfirm {
  type: RequirementConfirmTypeEnum;
  value: RequirementConfirmValueEnum | null;
  desc: string;
  sort: number;
  show: RequirementConfirmShowEnum;
}

export interface RequirementAdd {
  sourceType: SourceTypeEnum | null;
  sourceId: string | null;
  bomHisId: string;
  productId: string;
  desc: string;
  requireCount: string; // 需要多少
  estimatedCost: string; // 预估总成本
  items: Array<RequirementAddItem>;
  confirms: Array<RequirementConfirm>;
  mrd: number | null; // 要求齐料时间
  eps: number | null; // 预计上线时间
  preFinishDate?: number | null; // 预计完工时间
}

export enum RequirementAddItemUseRepl {
  NOT_USE,
  USED,
}

export interface RequirementAddItem {
  productId: string;
  bomItemId: string;
  bomReplId: string;
  useRepl: RequirementAddItemUseRepl; // 是否使用替代料
  maxEstimatedPriceId: string;
  minEstimatedPriceId: string;
  maxEstimatedCost: string;
  minEstimatedCost: string;
  useAmount: string;
  desc: string;
  purCount: string;
  puredCount: string;
  outCount: string;
  extCount: string; // 备货数量
  supplierId: string; // 供应商
  ert: number | null; // 预计交货时间
  attritionRate: string; // 子件损耗率
  baseCount: string; // 基本数量[bom]
  matchKey: string;   //前端匹配数据的临时字段
  bomAmount: string;  //  用量[bom]baseCount
  process?: string;
  useFactoryCount: number;
}
export enum RequirementItemDelEnum {
  NORMAL = 0,
  DEL = 1,
}
export interface RequirementItem extends RequirementAddItem {
  id: string;
  product: Product | null;
  maxPrice: ProductPrice | null;
  minPrice: ProductPrice | null;
  supplier: Supplier | null; // 供应商
  purchaseItems: Array<PurchaseOrderItem>;

  quoteItemCount: number; // 有问询单的item
  quoteRequestCount: number; // 有多少问询单
  quoteRequestReadCount: number; // 问询单有反馈的数量
  quotationRequest?: QuotationRequest;
  quotationRequests?: QuotationRequest[];
  requirement?: Requirement;
  equotationRequest: QuotationRequest | null;
  deleted: RequirementItemDelEnum;
  useAmount: string;
  inCount: number | null;
  tags: Array<TagLabel> | null;
  orderId: string;
}

export interface Requirement extends RequirementAdd {
  id: string;
  number: string;
  items: Array<RequirementItem>;
  product: Product | null;
  itemCount: string;
  readyCount: string;//物料准备进度
  confirms: Array<RequirementConfirm>;
  saleOrder: SaleOrderItemState;
  logBookId: string;
  status?: RequirementStatusEnum;
  createdAt: number | null;

  quoteItemCount: number; // 有问询单的item
  quoteRequestCount: number; // 有多少问询单
  quoteRequestReadCount: number; // 问询单有反馈的数量
  inventoryOrders: Array<InventoryOrdersItem>; // 出库单
  puredItemCount: number;//已采购数量
  creator?: User;
}

export enum QuotationRequestStatusEnum {
  UNREAD = 1,
  READ = 2,
  SUBMITED = 3,
  REJECTED = 4
}

export enum QuotationRequestSelectedEnum {
  UN_SELECTED = 0,
  SELECTED = 1,
}
export interface QuotationRequest {
  id: string;
  requirementItemId: string;
  count: number;
  supplierId: string;
  priceId: string;
  deadline?: number;
  mrd?: number;
  supplierPrice?: number | string;
  supplierTime: number;
  supplier: Supplier;
  days?: number | null;
  mpq?: string | null;
  price?: SupplierPrice | null;
  status: QuotationRequestStatusEnum;
  selected?: QuotationRequestSelectedEnum;
  purchaseItem?: PurchaseOrderItem;
  purchaseItemId?: string;
  requirementItem?: RequirementItem;
  exchangeRate: string;
  standardPrice: string;
  standardCurrency: string;
  spareCount?: number
  spareRate?: string
  remark?: string | null;
  creator?: User;
}
export interface RequirementTemplateAddItem {
  productId: string;
  useAmount: number;
  desc: string;
  attritionRate: string;
  baseCount: string;
  extCount: string;
}

export type RequirementTemplateAdd = Array<RequirementTemplateAddItem>;

export interface RequirementTemplateItem extends RequirementTemplateAddItem {
  id: string;
  creator: User;
  updater: User;
  product: Product;
}

export type RequirementTemplate = Array<RequirementTemplateItem>;
